import { render } from "./AppointmentsCalendar.vue?vue&type=template&id=1bb9bfd7&scoped=true"
import script from "./AppointmentsCalendar.vue?vue&type=script&lang=js"
export * from "./AppointmentsCalendar.vue?vue&type=script&lang=js"

import "./AppointmentsCalendar.vue?vue&type=style&index=0&id=1bb9bfd7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb9bfd7"]])

export default __exports__